import React from 'react';
import { Message, Tag } from 'rsuite';
import type { BagelDocumentStatusSummary } from '../../../api/bagel-documents';
import type { BagelDocumentStatus } from '../../../types';

const STATUS_CHIPS: Array<{
  key: BagelDocumentStatus;
  label: string;
  color: 'yellow' | 'blue' | 'green' | 'red';
}> = [
  { key: 'pending', label: 'Pending', color: 'yellow' },
  { key: 'processing', label: 'Processing', color: 'blue' },
  { key: 'error', label: 'Error', color: 'red' },
  { key: 'ready', label: 'Ready', color: 'green' },
];

export default function BagelDocumentProcessingSummary({
  summary,
  activeStatus,
  onStatusClick,
}: {
  summary: BagelDocumentStatusSummary;
  activeStatus: BagelDocumentStatus | 'all';
  onStatusClick: (status: BagelDocumentStatus | 'all') => void;
}) {
  const inFlight = summary.pending + summary.processing;

  return (
    <div style={{ marginBottom: 12 }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          alignItems: 'center',
        }}
      >
        <Tag
          size="sm"
          style={{ cursor: 'pointer' }}
          onClick={() => onStatusClick('all')}
        >
          All ({summary.total})
        </Tag>
        {STATUS_CHIPS.map(chip => {
          const count = summary[chip.key];
          const isActive = activeStatus === chip.key;
          return (
            <Tag
              key={chip.key}
              size="sm"
              color={chip.color}
              style={{
                cursor: count > 0 ? 'pointer' : 'default',
                opacity: count === 0 ? 0.5 : 1,
                outline: isActive
                  ? '2px solid var(--rs-text-primary)'
                  : undefined,
              }}
              onClick={() => {
                if (count > 0) onStatusClick(chip.key);
              }}
            >
              {chip.label} ({count})
            </Tag>
          );
        })}
      </div>
      {inFlight > 0 ? (
        <Message showIcon type="info" style={{ marginTop: 8 }}>
          {inFlight} document{inFlight === 1 ? '' : 's'} processing in the
          background — table auto-refreshes every 3s.
        </Message>
      ) : null}
    </div>
  );
}
